<template>
    <el-row class="grid-stack-item">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="header">
                <h1>{{ $t('Change Password') }}</h1>
            </div>
            <div class="my-content">
                <div class="grid-stack-item-content">
                    <el-form :label-position="labelPosition" :model="changePassword" :rules="rules" ref="changePassword">
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
                                <el-form-item :label="$t('Current Password')" prop="current_password">
                                    <el-input v-model="changePassword.current_password" type="password"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('New Password')" prop="new_password">
                                    <el-input v-model="changePassword.new_password" type="password"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('Confirm password')" prop="new_password_confirmation">
                                    <el-input v-model="changePassword.new_password_confirmation" type="password"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
                                <el-form-item class="no-margin">
                                    <el-button type="primary" @click="submitForm('changePassword')">{{ $t('Change Password') }}</el-button>
                                    <router-link tag="el-button" to="/dashboard" class="el-button--cancel">{{ $t('Cancel') }}</router-link>
                                </el-form-item>
                            </el-col>
                         </el-row>
                    </el-form>
                </div>
            </div>
        </el-col>
    </el-row>
</template>

<script>
    export default {
        data() {
            return {
                changePassword: {},
                labelPosition: "top",
                rules: {
                    current_password: [{
                            required: true,
                            message: this.$t('This field is required'),
                            trigger: "blur"
                        }
                    ],
                    new_password: [{
                            required: true,
                            message: this.$t('This field is required'),
                            trigger: "blur"
                        }
                    ],
                    new_password_confirmation: [{
                            required: true,
                            message: this.$t('This field is required'),
                            trigger: "blur"
                        }
                    ]
                }
            }
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.$parent.fullscreenLoading = true;
                        request({
                            url: "user/change-password",
                            method: "post",
                            data: this.changePassword
                        })
                        .then(response => {
                            this.$parent.fullscreenLoading = false;
                            this.$notify({
                                title: this.$t('Success'),
                                message: response.data.message,
                                type: "success",
                                offset: 50
                            });
                            this.$refs[formName].resetFields();
                            this.$store.dispatch("setConfig", {
                                user: response.data.user
                            });
                        })
                        .catch(error => {
                            this.$parent.fullscreenLoading = false;
                            this.$notify({
                                title: this.$t('Error'),
                                message: error.response.data.message,
                                type: "error",
                                offset: 50
                            });
                        });
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Layout/MyProfile/ChangePassword.vue